import React from 'react';
import { cx } from './utils';

export default function Badge({ children, tone = 'neutral', className }) {
  return <span className={cx('badge', `badge--${tone}`, className)}>{children}</span>;
}
